// Interruptor manual de la decoración temática del sitio.
// Valores posibles: 'invierno' | 'mundial' | 'navidad' | 'none'
//
// Cambiá esta única línea para prender/apagar o cambiar la decoración.
//   'invierno' -> nieve cayendo en todo el sitio + adorno animado (pinos) junto al logo.
//   'mundial'  -> splash "¡GOOOOL!" al cargar + hincha animado junto al logo.
//   'none'     -> sin decoración.
export const DECORACION = 'invierno';

// Cada cuánto el hincha festeja el gol (con confetti), en milisegundos.
// 120000 = 2 minutos. Subilo/bajalo a gusto. (Solo aplica a 'mundial'.)
export const CONFETTI_LOGO_INTERVAL_MS = 120000;

// Cantidad de copos de nieve en pantalla (decoración 'invierno').
export const NIEVE_COPOS = 42;
